<template>
    <div class="cp-header">
        <div @click="onTapMenuItem({}, 0)">
            <img
                class="cp-header-logo"
                :src="menu[current].mode === 'dark' ? logo.dark : logo.light"/>
        </div>
        <div
            class="cp-header-menu"
            ref="menu">
            <div
                v-for="(item, i) in menu"
                :key="i"
                ref="menuItem"
                class="cp-header-menu-item"
                :class="[
                    i === current ? 'current': '',
                    menu[current].mode === 'dark' ? 'dark' : ''
                ]"
                :style="{
                    'margin-left': i === 0 ? '' : '.54rem'
                }"
                @click="onTapMenuItem(item, i)">{{ item.title }}</div>
            <div
                class="cp-header-menu-line"
                :style="{
                    'left': lineSty.left + 'px',
                    'transition': 'all .3s ease-out'
                }"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'cp-header',
    components: {
    },
    props: {
        menu: {
            type: Array,
            default() {
                return [];
            }
        },
        current: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            logo: {
                light: require('@/images/logo_light.png'),
                dark: require('@/images/logo_dark.png')
            },
            pos: {
                items:[],
                line: {}
            },
            lineSty: {
                left: 0
            }
        }
    },
    watch: {
        current(v) {
            this.getLineSty(v);
        }
    },
    mounted() {
        this.$nextTick(() => {
            // 计算menu item位置
            this.getMenuItemPos();
            // 计算lineSty
            this.getLineSty(this.current);
        });
    },
    methods: {
        getMenuItemPos() {
            const line = parseFloat(getComputedStyle(this.$refs.menuItem[this.current], ':after').width, 10);
            this.pos = this.$refs.menuItem.map(el => {
                const rect = el.getBoundingClientRect();
                const {
                    width,
                    height,
                    top,
                    right,
                    bottom,
                    left
                } = rect;
                return Object.assign(
                    {
                        width,
                        height,
                        top,
                        right,
                        bottom,
                        left
                    },
                    {
                        line
                    }
                )
            });

        },
        getLineSty(index) {
            const curPos = this.pos[index];
            const left = (curPos.left - this.$refs.menu.getBoundingClientRect().left) + ((curPos.width - curPos.line) / 2);
            this.$set(this.lineSty, 'left', left);
        },
        onTapMenuItem(data, index) {
            this.getLineSty(index);
            this.$emit('tapMenuItem', {
                data,
                index
            });
        }
    }
}
</script>

<style scoped>

.cp-header {
    position: fixed;
    padding: .5rem 0 .48rem 0;
    left: .6rem;
    right: .6rem;
    display: flex;
    align-items: flex-end;
    justify-content: space-between;
    z-index: 5;
}
.cp-header-logo {
    width: 3.2rem;
}
.cp-header-menu {
    position: relative;
    white-space: nowrap;
    font-size: .18rem;
}
.cp-header-menu-item {
    position: relative;
    display: inline-block;
    color: #333;
    cursor: pointer;
    padding-bottom: .15rem;
    opacity: .8;
}
.cp-header-menu-item.dark {
    color: #fff;
}
.cp-header-menu-item.current::after {
    content: '';
    position: absolute;
    width: .48rem;
    height: .04rem;
    opacity: 1;
    border-radius: 1px;
    opacity: 0;
}
.cp-header-menu-item.current.dark {
    opacity: 1;
}
.cp-header-menu-line {
    position: absolute;
    width: .48rem;
    height: .04rem;
    opacity: 1;
    border-radius: 1px;
    background-color: #00C8C8;
    left: 0;
    bottom: 0;
    z-index: 5;
}
</style>



// WEBPACK FOOTER //
// src/components/home/Header.vue